<template>
  <div>
    <el-popover
      placement="bottom-start"
      width="290"
      v-model="visible"
      popper-class="my_proper_areaCode"
    >
      <el-input
        :placeholder="$t('lang.搜索')"
        prefix-icon="el-icon-search"
        class="my_input_search"
        v-model="searchQuery"
      ></el-input>
      <div class="my_areaCodeList" v-if="areaCodeListCopy.length !== 0">
        <div
          v-for="(item, index) in areaCodeListCopy"
          :key="index"
          @click="onClickAreaCode(item.timeZoneCode)"
        >
          <span class="overflow">
            {{
              $i18n.locale == "zh-CN" ? item.nationNameZh : item.nationNameEn
            }}
          </span>
          <span>{{ item.timeZoneCode }}</span>
        </div>
      </div>
      <div class="my_noData" v-else>{{ $t("lang.暂无数据") }}</div>
      <span slot="reference" class="areaCode">{{ selAreaCode }}</span>
    </el-popover>
  </div>
</template>

<script>
import { mapActions } from "vuex";
export default {
  components: {},
  data() {
    return {
      visible: false,
      selAreaCode: "+86",
      areaCodeList: [],
      areaCodeListCopy: [],
      searchQuery: "",
      localLanguage: "",
    };
  },
  watch: {
    searchQuery(val) {
      const searchValue = val.trim().toLowerCase();
      this.areaCodeListCopy = this.areaCodeList.filter(
        (item) =>
          item.nationNameZh.toLowerCase().includes(searchValue) ||
          item.nationNameEn.toLowerCase().includes(searchValue) ||
          item.timeZoneCode.toLowerCase().includes(searchValue)
      );
    },
    visible() {
      this.searchQuery = "";
    },
  },
  created() {
    this.getAreaCode();
  },
  methods: {
    ...mapActions({
      countryConfigurationList: "ZD_CountryConfigurationList",
    }),
    /**选择区号 */
    onClickAreaCode(code) {
      this.visible = false;
      this.selAreaCode = code;
    },
    /**获取区号 */
    async getAreaCode() {
      let areaCode = this.$store.getters["areaCode/countriesAndRegions"];
      if (!this.isnull(areaCode)) {
        this.areaCodeList = areaCode;
        this.areaCodeListCopy = this.docopy(areaCode);
        return;
      }
      let res = await this.countryConfigurationList({});
      if (res.success !== 1) return;
      this.areaCodeList = res.listItem;
      this.areaCodeListCopy = this.docopy(this.areaCodeList);
      this.$store.commit("areaCode/countriesAndRegions", res.listItem);
    },
  },
};
</script>

<style scoped lang='css'>
.areaCode {
  color: #409eff;
  font-size: 15px;
  cursor: pointer;
  position: absolute;
  left: 10px;
  z-index: 2;
}
</style>
<style lang="less">
.my_proper_areaCode {
  padding: 12px 0;
}
.my_input_search {
  width: 250px !important;
  margin: 0 20px 10px;
}
.my_noData {
  text-align: center;
  height: 170px;
  margin-top: 30px;
}
.my_areaCodeList {
  height: 200px;
  overflow-y: auto;
  div {
    display: flex;
    justify-content: space-between;
    padding: 6px 30px;
    cursor: pointer;
  }
  div:hover {
    background: #edf5ff;
  }
}
.overflow {
  width: 175px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
</style>